<template>
  <div v-if="extension" style="margin: 0 15px">
    <el-tabs v-model="tabType">
      <el-tab-pane label="插件详情" name="Details"></el-tab-pane>
      <el-tab-pane label="版本历史" name="Releases"></el-tab-pane>
      <el-tab-pane label="插件说明" name="Content"></el-tab-pane>
      <el-tab-pane label="更新日志" name="ChangeLog"></el-tab-pane>
    </el-tabs>

    <template v-if="tabType == 'Releases'">
      <el-table :data="releases">
        <el-table-column label="版本号">
          <template #default="scope">
            {{ scope.row.version }}
          </template>
        </el-table-column>
        <el-table-column label="CMS版本">
          <template #default="scope">
            {{ scope.row.enginesCms }}
          </template>
        </el-table-column>
        <el-table-column label="依赖项">
          <template #default="scope">
            {{ scope.row.engines }}
          </template>
        </el-table-column>
        <el-table-column label="发布时间">
          <template #default="scope">
            {{ scope.row.createdDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-link type="primary" :underline="false" :href="getDownloadReleaseUrl(scope.row)">下载</el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-else-if="tabType == 'Content'">
      <p v-html="extension.content"></p>
    </template>
    <template v-else-if="tabType == 'ChangeLog'">
      <p v-html="extension.changeLog"></p>
    </template>
    <template v-else-if="tabType == 'Details'">
      <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
            <colgroup>
              <col width="180" />
              <col />
            </colgroup>
            <tbody>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>插件状态</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <el-link :type="extension.state == 'Published' ? 'success' : 'danger'" :underline="false">
                      {{ getResourceState(extension) }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>插件作者</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">{{ extension.userName }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>插件名称</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">{{ extension.name }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>显示名称</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">{{ extension.displayName }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>插件价格</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <span v-if="extension.price == 0">免 费</span>
                    <span v-else>￥{{ extension.price.toFixed(2) }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>插件简介</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">{{ extension.description }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>开源许可</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">{{ extension.license }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>项目地址</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <el-link
                      v-if="extension.projectUrl"
                      type="primary"
                      :underline="false"
                      :href="extension.projectUrl"
                      target="_blank"
                    >
                      {{ extension.projectUrl }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>分类</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell" v-if="extension.categories">
                    <el-link
                      v-for="category in extension.categories"
                      :key="category"
                      type="primary"
                      :underline="false"
                      style="margin-right: 5px"
                    >
                      {{ category }}
                    </el-link>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1">
                  <div class="cell">
                    <strong>标签</strong>
                  </div>
                </td>
                <td rowspan="1" colspan="1">
                  <div class="cell" v-if="extension.keywords">
                    <el-link
                      v-for="tag in extension.keywords"
                      :key="tag"
                      type="primary"
                      :underline="false"
                      style="margin-right: 5px"
                    >
                      {{ tag }}
                    </el-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="el-table__column-resize-proxy" style="display: none"></div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { IExtension, IRelease } from '@/types/models';
import { defineComponent, PropType } from 'vue';
import utils from '@/utils';

interface IState {
  tabType: string;
}

export default defineComponent({
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
    releases: {
      type: Object as PropType<IRelease>,
      required: true,
    },
  },
  data() {
    return {
      tabType: 'Details',
    } as IState;
  },
  methods: {
    getResourceState(extension: IExtension) {
      return utils.getResourceState(extension.state, extension.isFeatured);
    },

    getDownloadReleaseUrl(release: IRelease) {
      return `https://dl.sscms.com/extensions/${this.extension.userName}/${this.extension.name}/${this.extension.userName}.${this.extension.name}.${release.version}.zip`;
    },
  },
  watch: {
    extension() {
      this.tabType = 'Details';
    },
  },
});
</script>
